module.exports = __webpack_public_path__ + "a4de1901801eef62ad1ea9a92ba9195d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/annemarie_berlinger_landscape.jpg
// module id = 341
// module chunks = 0